var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 162,
    height: 162,
    viewBox: "0 0 162 162",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M156 74.1429V81.0429C155.991 97.2161 150.754 112.953 141.07 125.907C131.386 138.86 117.775 148.336 102.265 152.922C86.7557 157.508 70.1794 156.957 55.0085 151.352C39.8376 145.747 26.8849 135.389 18.0822 121.821C9.2795 108.253 5.09843 92.2034 6.16258 76.0653C7.22672 59.9271 13.479 44.5654 23.9871 32.271C34.4951 19.9766 48.6959 11.4083 64.4714 7.84402C80.2469 4.27975 96.752 5.91046 111.525 12.4929",
    stroke: "url(#paint0_linear_8588_2679)",
    strokeWidth: 11.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M156 21.0419L81 96.1169L58.5 73.6169",
    stroke: "url(#paint1_linear_8588_2679)",
    strokeWidth: 11.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8588_2679",
    x1: 81,
    y1: 6,
    x2: 81,
    y2: 156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8FFFD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#33FFB6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8588_2679",
    x1: 107.25,
    y1: 21.0419,
    x2: 107.25,
    y2: 96.1169,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8FFFD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#33FFB6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.fe568e38e0d8580c01c32a26d9034b45.svg";
export { ForwardRef as ReactComponent };